import { render, staticRenderFns } from "./VideoSection.vue?vue&type=template&id=57d11c82&scoped=true&"
import script from "./VideoSection.vue?vue&type=script&lang=js&"
export * from "./VideoSection.vue?vue&type=script&lang=js&"
import style0 from "./VideoSection.vue?vue&type=style&index=0&id=57d11c82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d11c82",
  null
  
)

export default component.exports